export const M2M_OIDC_TOKEN_CONFIG = "M2M_OIDC_TOKEN_CONFIG";
export const ECOPILOT_M2M_OIDC_TOKEN_CONFIG = "ECOPILOT_M2M_OIDC_TOKEN_CONFIG";
export const CONFIG_CAT_PUBLIC_KEY = "CONFIG_CAT_PUBLIC_KEY";
export const DATABASE = "DATABASE";
export const EFDB_SERVICE_URL = "EFDB_SERVICE_URL";
export const DOCUMENT_HUB_SERVICE_URL = "DOCUMENT_HUB_SERVICE_URL";
export const DATA_AGGREGATOR_SERVICE_URL = "DATA_AGGREGATOR_SERVICE_URL";
export const PCF_REPORT_EXTRACTION_MODEL = "PCF_REPORT_EXTRACTION_MODEL";
export const ECOPILOT_SERVICE_URL = "ECOPILOT_SERVICE_URL";
export const TYPESENSE_HOST = "TYPESENSE_HOST";
export const TYPESENSE_PORT = "TYPESENSE_PORT";
export const TYPESENSE_API_KEY = "TYPESENSE_API_KEY";
export const TYPESENSE_PROTOCOL = "TYPESENSE_PROTOCOL";
export const MOCK_TYPESENSE = "MOCK_TYPESENSE";
export const TLS_CA_FILE_PATH = "TLS_CA_FILE_PATH";
export const MONGO_MAX_POOL_SIZE = "MONGO_MAX_POOL_SIZE";
export const EMAIL_SERVICE_URL = "EMAIL_SERVICE_URL";
export const EMAIL_SERVICE_FROM_ADDRESS = "EMAIL_SERVICE_FROM_ADDRESS";
/** Service-delivery inbox that turns a purchased PCF validation into a Dynamics order. */
export const SERVICE_DELIVERY_EMAIL = "SERVICE_DELIVERY_EMAIL";
export const EMAIL_FEEDBACK_QUEUE_URL = "EMAIL_FEEDBACK_QUEUE_URL";
export const ANALYTICS_QUEUE_URL = "ANALYTICS_QUEUE_URL";
export const SQS_ENDPOINT = "SQS_ENDPOINT";
export const AWS_ACCESS_KEY_ID = "AWS_ACCESS_KEY_ID";
export const AWS_SECRET_ACCESS_KEY = "AWS_SECRET_ACCESS_KEY";
export const AWS_SESSION_TOKEN = "AWS_SESSION_TOKEN";
export const AWS_DEFAULT_REGION = "AWS_DEFAULT_REGION";
export const FRONTEND_URL = "FRONTEND_URL";
export const SERVICE_PUBLIC_URL = "SERVICE_PUBLIC_URL";
export const QUESTIONNAIRE_URL = "QUESTIONNAIRE_URL";
export const CIM_SERVICE_URL = "CIM_SERVICE_URL";
export const NODE_ENV = "NODE_ENV";
export const GOOGLE_API_KEY = "GOOGLE_API_KEY";
export const UNIFIED_API_TOKEN = "UNIFIED_API_TOKEN";
export const UNIFIED_API_ENDPOINT_URL = "UNIFIED_API_ENDPOINT_URL";
export const AZURE_OPENAI_SECRET = "AZURE_OPENAI_SECRET";
export const ENVIRONMENT = "ENVIRONMENT";

// env config keys (local)
export const MINIO_ENDPOINT = "MINIO_ENDPOINT";
export const MINIO_ROOT_USER = "MINIO_ROOT_USER";
export const MINIO_ROOT_PASSWORD = "MINIO_ROOT_PASSWORD";

export const MONGO_CLIENT = "MongoClient";
export const MONGO_CLIENT_INSTANCE = Symbol("MongoDbClient");

export const FEATURE_TOGGLE = "FeatureToggle";

export const FPC_DATABASE_NAME = "fpc";
export const CCF_CALCULATION_COLLECTION = "ccfCalculation";
// One document per calculation, keyed by calculationId — no synthetic id needed.
export const EMISSION_FACTORS_MANAGERS_COLLECTION = "emissionFactorsManagers";
export const CUSTOMER_GROUPING_COLLECTION = "customerGrouping";
export const CALCULATION_UPDATE_HISTORY_COLLECTION = "calculationUpdateHistory";
export const ORDER_COLLECTION = "order";

export const CURATED_COOLING_COLLECTION = "curatedCooling";
export const CURATED_ELECTRICITY_COLLECTION = "curatedElectricity";
export const CURATED_HOME_OFFICE_COLLECTION = "curatedHomeOffice";
export const CURATED_EMPLOYEE_COMMUTING_COLLECTION = "curatedContinentEmployeeCommuting";
export const CURATED_HOTEL_STAYS_COLLECTION = "curatedHotelStays";
export const CURATED_FLIGHT_CLASS_COLLECTION = "curatedFlightClass";
export const CURATED_FUGITIVE_COLLECTION = "curatedFugitive";
export const CURATED_HEATING_AND_FUEL_COLLECTION = "curatedHeatingAndFuel";
export const CURATED_MEANS_OF_TRANSPORT_COLLECTION = "curatedMeansOfTransport";
export const CURATED_PRIVATE_AND_RENTAL_VEHICLE_COLLECTION = "curatedPrivateAndRentalVehicle";
export const CURATED_RAIL_TRAVEL_COLLECTION = "curatedRailTravel";
export const CURATED_REFRIGERANT_COLLECTION = "curatedRefrigerant";
export const CURATED_TRANSPORT_COLLECTION = "curatedTransport";
export const CURATED_VEHICLE_FUEL_TYPE_COLLECTION = "curatedVehicleFuelType";
export const CURATED_WASTE_CATEGORY_COLLECTION = "curatedWasteCategory";
export const DEFAULT_VALUES_COLLECTION = "defaultValues";
export const INVITATION_COLLECTION = "invitation";
export const CALCULATION_FACTORS_UPDATE_STATUS_COLLECTION = "calculationFactorsUpdateStatus";
export const DATA_HUB_BACKFILL_LOCK_COLLECTION = "dataHubBackfillLock";
export const CURATED_WATER_COLLECTION = "curatedWater";
export const CURATED_BEVERAGES_COLLECTION = "curatedBeverages";
export const CURATED_FOOD_COLLECTION = "curatedFood";
export const EMISSION_FACTORS_COLLECTION = "emissionFactors";
export const CUSTOMER_EMISSION_FACTORS_COLLECTION = "customerEmissionFactors";
export const EXTRACTED_PCF_REPORT_DRAFT_COLLECTION = "extractedPcfReportDraft";
export const PRODUCT_COLLECTION = "product";
export const PCF_COLLECTION = "pcf";

export const DISPOSAL_DATA_ENTRIES_COLLECTION = "disposal_disposal";

export const LOGISTICS_OPERATIONS_COLLECTION = "logisticsOperations";

export const GLOBAL_ISO_CODE = "Global";
export const REST_OF_WORLD_ISO_CODE = "Rest of World";
export const CONTINENT_ISO_CODES = [
  "Africa-AF",
  "Asia-AS",
  "Europe-EU",
  "North America-NA",
  "Oceania-OC",
  "South America-SA",
];

export const UNMOCK_PLACES = "UNMOCK_PLACES";

export const CUSTOMER_ID_PARAM_KEY = "customerId";

export const CP_EMPLOYEE_ACCESS_PERMISSION_KEY = "cp.employee.access";
export const CP_EMPLOYEE_ELEVATED_PERMISSION_KEY = "cphub.employee.elevated";
// Holding any one of these makes a user elevated (customer manager / CP employee).
export const ELEVATED_USER_PERMISSION_KEYS = [CP_EMPLOYEE_ACCESS_PERMISSION_KEY, CP_EMPLOYEE_ELEVATED_PERMISSION_KEY];
export const CP_CUSTOMER_TRIAL_PERMISSION_KEY = "cphub.trial.access";
export const CFC_EMISSION_FACTOR_VIEW_PERMISSION_KEY = "cfc.emission-factor.view";
export const NETWORK_BUYER_V2_ACCESS_PERMISSION_KEY = "network-buyer-v2.access";
export const NETWORK_SUPPLIER_V2_ACCESS_PERMISSION_KEY = "network-supplier-v2.access";
export const REDUCTION_FULL_ACCESS_PERMISSION_KEY = "reduction-module.access";

// ConfigCat flag routing customer-request support emails to the requester's own inbox instead of
// the CRM contact; backend-only, no frontend counterpart (see docs/common-tasks.md)
export const CUSTOMER_REQUEST_EMAIL_OVERRIDE_FEATURE_FLAG = "customerRequestEmailOverride";

export enum CimServiceNames {
  CCF_BASIC = "cfc",
  CCF_ENTERPRISE = "cfc.ccf-enterprise",
  CCF_ASSESSMENT = "cfc.ccf-assessment",
  CCF_EMPLOYEE_COMMUTING = "cfc.ccf-employee-commuting-survey",
  PCF = "cfc.pcf",
  TRIAL = "cphub.trial",
}

export enum AccessTokenServiceNames {
  CCF_BASIC = "cfc.ccf-basic.access",
  CCF_ENTERPRISE = "cfc.ccf-enterprise.access",
  CCF_ASSESSMENT = "cfc.ccf-assessment.access",
  CCF_EMPLOYEE_COMMUTING = "cfc.ccf-employee-commuting-survey.access",
  PCF = "cfc.pcf.access",
  TRIAL = "cphub.trial.access",
}

export const CSRD_SERVICE_NAME = "cfc.ccf-csrd";

export const CURATED_CALCULATION_FACTORS_UPDATED = "curated-calculation-factors.updated";

export const ECOPILOT_QUEUE_URL = "ECOPILOT_QUEUE_URL";

export const DATA_HUB_SYNC_QUEUE_URL = "DATA_HUB_SYNC_QUEUE_URL";

export const DATA_HUB_OUT_DB = "DATA_HUB_OUT_DB";

export const DATA_HUB_SYNC_DB_POOL_SIZE = "DATA_HUB_SYNC_DB_POOL_SIZE";

// Pause between per-calc backfills, so a bulk run can't starve the live app. Unset → default; "0" disables.
export const BACKFILL_INTER_CALC_DELAY_MS = "BACKFILL_INTER_CALC_DELAY_MS";
export const BACKFILL_RUN_ID = "BACKFILL_RUN_ID";
export const BACKFILL_SHARD_INDEX = "BACKFILL_SHARD_INDEX";
export const BACKFILL_SHARD_COUNT = "BACKFILL_SHARD_COUNT";
export const BACKFILL_FORCE_FULL_WRITE = "BACKFILL_FORCE_FULL_WRITE";
// Narrows the CFC-2984 waste recalculation migrator to one customer. Unset or empty → every customer.
export const PCF_WASTE_RECALCULATION_CUSTOMER_ID = "PCF_WASTE_RECALCULATION_CUSTOMER_ID";
// "resync-electronic-disposal" runs the CFC-3009 repair instead of the recalculation; any other value or unset → recalculation.
export const PCF_WASTE_RECALCULATION_TASK = "PCF_WASTE_RECALCULATION_TASK";

// Modules take a schema-per-module slice of the shared relational cluster (RELATIONAL_DATABASE): each
// gets its own DataSource and its own schema, so no other module can reach its tables or migration
// history. The schema name doubles as the DataSource name: one constant per module, not two.
export const NETWORK_DATABASE_SCHEMA = "network";
export const REDUCTION_DATABASE_SCHEMA = "reduction";
export const HOMESCREEN_DATABASE_SCHEMA = "homescreen";
export const COLLABORATION_DATABASE_SCHEMA = "collaboration";

export const RELATIONAL_DATABASE = "RELATIONAL_DATABASE";

export const MOCK_ECOPILOT = "MOCK_ECOPILOT";
export const MOCK_ECOPILOT_DELAY_MS = "MOCK_ECOPILOT_DELAY_MS";
